import React, { useState } from 'react';
import classNames from 'classnames';
import '../styles/group-avatar.css';
import { APP_PATH } from '../../../constants/appConfig';

const getInitials = (groupName) => {
    if (groupName) {
        const prepareGroupName = groupName.replace(/\s+/g, ' ').trim();
        const splittedString = prepareGroupName
            .replace(/\s+/g, ' ')
            .trim()
            .split(' ');
        if (splittedString.length > 1) {
            return splittedString
                .slice(0, 2)
                .map((item) => item.charAt(0))
                .join('')
                .toUpperCase();
        } else {
            return prepareGroupName.slice(0, 2).toUpperCase();
        }
    } else {
        return '';
    }
};

const GroupAvatar = ({ groupName = '', icon = null, avatarUrl = '' }) => {
    const [imgFailed, setImgFailed] = useState(false);
    return (
        <div className={'sk-avatar-wrapper fade-in-fast'}>
            <div className={'sk-group-avatar'}>
                {!imgFailed && avatarUrl ? (
                    <img
                        className={'sk-expert-avatar'}
                        src={`${APP_PATH}${avatarUrl}`}
                        alt={groupName}
                        onError={(e) => {
                            setImgFailed(true);
                        }}
                    />
                ) : (
                    getInitials(groupName) || ''
                )}
            </div>
            {icon}
        </div>
    );
};

export const GroupChoice = ({
    groupName = '',
    active = false,
    icon = null,
    avatarUrl = '',
}) => {
    const wrapCls = classNames('sk-group-avatar-wrap flex-grow', {
        'sk-group-avatar-wrap-active': active,
    });

    return (
        <div className={'sk-avatar-wrapper fade-in-fast'}>
            <div className={wrapCls}>
                <div className={'sk-group-avatar'}>
                    {avatarUrl ? (
                        <img
                            className={'sk-expert-avatar'}
                            src={`${APP_PATH}${avatarUrl}`}
                            alt={groupName}
                        />
                    ) : (
                        getInitials(groupName) || ''
                    )}
                </div>
            </div>
            {icon}
        </div>
    );
};

export default GroupAvatar;
